export default {
    UNITARIO: {texto: 'Valor Unitário', valor: 'UNITARIO'},
    TOTAL: {texto: 'Valor Total', valor: 'TOTAL'}
}
